import React from 'react';
import {
  BarChart3,
  Server,
  FileText,
  Gauge,
  Shield,
  Eye,
  Bell,
  List,
  Plus,
  Map,
  Box,
  Activity,
  Search,
  Zap,
  Globe,
  GitBranch,
  Network,
  AlertTriangle,
  Cloud,
  CheckCircle,
  Settings,
  Calendar,
  AlertCircle,
  Menu,
  X,
  Minus,
  ChevronDown,
  ChevronRight,
  ChevronUp,
  Home,
  Users,
  Folder,
  Database,
  Monitor,
  Lock,
  Sun,
  Moon,
  // New icons for Korean menu
  CheckSquare,
  Star,
  ShoppingCart,
  Package,
  FolderOpen,
  History,
  Book,
  Calculator,
  TrendingUp,
  DollarSign,
  Building,
  UserCog,
  Users as UsersIcon,
  MessageCircle,
  Send,
  ChevronLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  Clock,
  Briefcase,
  LayoutGrid,
  LayoutList,
  Grid3X3,
  User,
  Layers,
  BookOpen,
  type LucideIcon,
} from 'lucide-react';

const iconMap: Record<string, LucideIcon> = {
  // Main menu icons
  BarChart3,
  Server,
  FileText,
  Gauge,
  Shield,
  Eye,
  Bell,
  
  // Sub menu icons
  List,
  Plus,
  Map,
  Box,
  Activity,
  Search,
  Zap,
  Globe,
  GitBranch,
  Network,
  AlertTriangle,
  Cloud,
  CheckCircle,
  Settings,
  Calendar,
  AlertCircle,
  
  // UI icons
  Menu,
  X,
  Minus,
  ChevronDown,
  ChevronRight,
  ChevronUp,
  Home,
  Users,
  Folder,
  Database,
  Monitor,
  Lock,
  Sun,
  Moon,
  
  // New Korean menu icons
  CheckSquare,
  Star,
  ShoppingCart,
  Package,
  FolderOpen,
  History,
  Book,
  Calculator,
  TrendingUp,
  DollarSign,
  Building,
  UserCog,
  UsersIcon,
  MessageCircle,
  Send,
  ChevronLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  Clock,
  Briefcase,
  LayoutGrid,
  LayoutList,
  Grid3X3,
  User,
  Layers,
  BookOpen,
};

interface IconProps {
  name: string;
  size?: number;
  className?: string;
}

// 이모지 아이콘 맵
const emojiMap: Record<string, string> = {
  '📋': '📋',
  '👤': '👤', 
  '👥': '👥',
};

export const Icon: React.FC<IconProps> = ({ name, size = 20, className = '' }) => {
  // 이모지인 경우
  if (emojiMap[name]) {
    return (
      <span 
        className={`inline-flex items-center justify-center ${className}`}
        style={{ fontSize: `${size}px`, lineHeight: 1 }}
      >
        {emojiMap[name]}
      </span>
    );
  }
  
  // Lucide 아이콘인 경우
  const IconComponent = iconMap[name];
  
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return <div className={`w-5 h-5 ${className}`} />;
  }
  
  return <IconComponent size={size} className={className} />;
};

export default Icon;
